import { render, staticRenderFns } from "./SelectCustomerSupplier.vue?vue&type=template&id=bdaab9ac&scoped=true&"
import script from "./SelectCustomerSupplier.vue?vue&type=script&lang=js&"
export * from "./SelectCustomerSupplier.vue?vue&type=script&lang=js&"
import style0 from "./SelectCustomerSupplier.vue?vue&type=style&index=0&id=bdaab9ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdaab9ac",
  null
  
)

export default component.exports